// Robust mock data for Halsnæs Epoxygulve

export const CONTACT_INFO = {
  company: "Halsnæs Epoxygulve",
  owner: "Simon Babiel",
  phone: "93806489",
  email: "halsnaesepoxygulve@gmail.com",
  cvr: "46184319",
  address: "Åsebro 29, 3300 Frederiksværk",
  hours: "Mandag - Fredag: 07:00 - 17:00 | Lørdag: Efter aftale"
};

export const SERVICES = [
  {
    title: "Epoxygulve",
    slug: "epoxygulve",
    shortDesc: "Ekstremt slidstærke og rengøringsvenlige gulve med en flot, fugefri finish. Perfekt til både erhverv, garager og private boliger.",
    longDesc: "Epoxygulve er kendt for deres uovertrufne styrke og glatte, fugefrie overflade. Halsnæs Epoxygulve leverer skræddersyede epoxy-løsninger, der modstår tung belastning, kemikalier og dagligt slid, samtidig med at de fremstår yderst præsentable og moderne.",
    icon: "fa-solid fa-layer-group",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/5961f5ff-ebf1-44e6-b9b5-afb30420abff/service-epoxy.jpg",
    benefits: [
      "Høj slidstyrke og lang levetid",
      "Fugefri og ekstremt rengøringsvenlig overflade",
      "Stort udvalg af farver og glansgrader",
      "Kemikalie- og væskeresistent"
    ]
  },
  {
    title: "Industrigulve",
    slug: "industrigulve",
    shortDesc: "Tungt belastbare gulvløsninger til lagerhaller, produktionsmiljøer og værksteder. Optimeret til maskiner og kemisk påvirkning.",
    longDesc: "Industrigulve skal kunne tåle alt fra tunge gaffeltrucks til spild af kemikalier og olier. Vi udfører professionelle industrigulve i epoxy og polyurethan-beton, der overholder alle gældende krav til sikkerhed, hygiejne og skridsikkerhed i erhvervsbyggeri.",
    icon: "fa-solid fa-industry",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/5961f5ff-ebf1-44e6-b9b5-afb30420abff/service-industrial.jpg",
    benefits: [
      "Tåler ekstrem mekanisk og termisk belastning",
      "Skridsikre overflader (R9 til R13 klassificering)",
      "Hygiejniske og godkendt til fødevareproduktion",
      "Minimerer støv og letter den daglige rengøring"
    ]
  },
  {
    title: "Fugefrie gulve",
    slug: "fugefrie-gulve",
    shortDesc: "Moderne og komfortable polyurethan-gulve (PU) til kontorer, showrooms, institutioner og private designbevidste hjem.",
    longDesc: "Fugefrie gulve i polyurethan (PU) er blødere og mere elastiske end traditionel epoxy. Det giver en fantastisk gangkomfort, lyddæmpning og et minimalistisk, ubrudt look, der er ideelt til moderne kontorlandskaber, showrooms og private boliger.",
    icon: "fa-solid fa-sparkles",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/5961f5ff-ebf1-44e6-b9b5-afb30420abff/service-seamless.jpg",
    benefits: [
      "Blød og behagelig gangkomfort",
      "Lyddæmpende og stødabsorberende effekt",
      "Revneoverbyggende og elastisk materiale",
      "Stilrent, skandinavisk og fugefrit design"
    ]
  }
];

export const BENEFITS = [
  {
    title: "Uovertruffen Holdbarhed",
    desc: "Vores epoxy- og specialgulve er designet til at modstå ekstrem mekanisk belastning, tung trafik og dagligt slid i årtier.",
    icon: "fa-solid fa-shield-halved"
  },
  {
    title: "Kemikalieresistens",
    desc: "Modstandsdygtig over for syrer, olier, opløsningsmidler og skrappe rengøringsmidler. Perfekt til værksteder og industri.",
    icon: "fa-solid fa-flask"
  },
  {
    title: "Skridsikkerhed & Sikkerhed",
    desc: "Vi tilpasser overfladens struktur med skridsikre materialer, så arbejdsmiljøet altid er sikkert – selv i våde zoner.",
    icon: "fa-solid fa-shoe-prints"
  },
  {
    title: "Kvalitetssikring",
    desc: "Simon Babiel fører personligt tilsyn med alle projekter. Vi anvender kun certificerede materialer af højeste europæiske standard.",
    icon: "fa-solid fa-award"
  },
  {
    title: "Professionel Rådgivning",
    desc: "Vi hjælper dig med at vælge den helt rette gulvtype baseret på belastning, æstetik, rengøringskrav og budget.",
    icon: "fa-solid fa-comments"
  },
  {
    title: "Dansk Håndværk & Service",
    desc: "Halsnæs Epoxygulve står for pålidelighed, præcision og gennemsigtighed. Vi overholder altid aftalte tidsplaner og priser.",
    icon: "fa-solid fa-handshake"
  }
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Rådgivning & Opmåling",
    desc: "Vi besigtiger opgaven, måler op og rådgiver dig om det optimale materialevalg ud fra dine specifikke krav til slidstyrke og æstetik."
  },
  {
    step: "02",
    title: "Grundig Forberedelse",
    desc: "Undergulvet slibes eller slyngrenses for at fjerne urenheder og sikre optimal vedhæftning. Eventuelle revner og huller udbedres."
  },
  {
    step: "03",
    title: "Grunding & Primer",
    desc: "Vi påfører en specialprimer, der forsegler undergulvet og skaber den perfekte kemiske binding til det efterfølgende epoxy- eller PU-lag."
  },
  {
    step: "04",
    title: "Udlægning af slidlag",
    desc: "Selve epoxy- eller polyurethanbelægningen udlægges i den ønskede tykkelse og farve med professionelt præcisionsværktøj."
  },
  {
    step: "05",
    title: "Topcoat & Finish",
    desc: "Afslutningsvis påføres en slidstærk topcoat – mat, halvmat eller blank – eventuelt med skridsikring eller dekorative farveflager."
  }
];

export const TESTIMONIALS = [
  {
    name: "Mads Hansen",
    role: "Værkfører, MH Autoteknik",
    text: "Halsnæs Epoxygulve har lagt et fantastisk flot og slidstærkt epoxygulv i vores værksted. Det tåler spild af olie og tunge donkrafte uden problemer. Simon leverede til tiden og ydede en super service.",
    rating: 5
  },
  {
    name: "Kirsten Jensen",
    role: "Showroom Ansvarlig, Nordisk Design",
    text: "Vi fik lagt et fugefrit polyurethan-gulv i vores nye showroom. Resultatet er utrolig smukt og minimalistisk. Gangkomforten er i top, og det er utrolig nemt at holde rent. Kan varmt anbefales!",
    rating: 5
  },
  {
    name: "Thomas Poulsen",
    role: "Produktionschef, ScanFood A/S",
    text: "Vores krav til hygiejne og skridsikkerhed var ekstremt høje. Halsnæs Epoxygulve rådgav os professionelt og udførte et fugefrit industrigulv, der fuldstændig lever op til fødevarestyrelsens krav.",
    rating: 5
  },
  {
    name: "Simon Lindegaard",
    role: "Privat boligejer, Frederiksværk",
    text: "Fik lavet epoxygulv i min dobbelte garage med grå farveflager. Det ser super professionelt ud, og det er en fornøjelse at arbejde derude nu. Simon Babiel er en yderst behagelig og dygtig håndværker.",
    rating: 5
  },
  {
    name: "Charlotte Friis",
    role: "Ejer, Klinik Balance",
    text: "Det fugefrie gulv i vores klinik har givet lokalerne et enormt løft. Det er lyddæmpende, blødt at gå på hele dagen, og patienterne bemærker ofte det flotte, rene look. Fantastisk arbejde!",
    rating: 5
  },
  {
    name: "Jesper Østergaard",
    role: "Lagerchef, Logistik Partner",
    text: "Vores 1.200 kvm lagerhal har fået nyt epoxygulv. Processen forløb fuldstændig smertefrit, og Simon og hans team formåede at arbejde omkring vores drift, så vi minimerede nedetid. Fremragende håndværk.",
    rating: 5
  }
];

export const FAQS = [
  {
    q: "Hvor lang tid tager det at lægge et epoxygulv?",
    a: "Typisk tager processen mellem 3 og 5 dage. Det skyldes, at der er flere faser med slibning, priming, udlægning af slidlag og hærdning imellem lagene. Gulvet kan normalt betrædes efter 24 timer, men skal hærde fuldt ud (ca. 7 dage) før tung belastning."
  },
  {
    q: "Hvad er forskellen på epoxy og polyurethan (PU)?",
    a: "Epoxy er ekstremt hårdt og har en uovertruffen slidstyrke over for mekanisk belastning og kemikalier, hvilket gør det ideelt til industri, værksteder og garager. Polyurethan (PU) er mere elastisk, hvilket giver bedre gangkomfort, lyddæmpning og revneoverbygning, hvilket gør det ideelt til kontorer, klinikker og private boliger."
  },
  {
    q: "Kan man lægge epoxy ovenpå gulvvarme?",
    a: "Ja, fugefrie gulve (især polyurethan, men også visse epoxytyper) fungerer fremragende med gulvvarme. Da belægningen er tynd og har god varmeledningsevne, opnår man en effektiv og behagelig varmefordeling."
  },
  {
    q: "Hvordan vedligeholder og rengør man et fugefrit gulv?",
    a: "Fugefrie gulve er utroligt nemme at rengøre, da der ikke er nogen fuger, hvor snavs kan samle sig. Daglig rengøring klares med støvsugning og vask med et mildt, neutralt rengøringsmiddel. Undgå skrappe syreholdige midler på epoxy."
  }
];
